<span class="material-symbols-outlined text-jungle-green shrink-0 text-[20px] md:text-[24px]" aria-hidden="true">location_on</span>
<div class="relative flex flex-col text-left w-full">
  <label [attr.for]="uid + '-input'" class="text-[10px] uppercase tracking-widest font-bold text-muted-text">{{ label }}</label>
  <input
    [id]="uid + '-input'"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    (keydown)="onKeydown($event)"
    (focus)="onFocus()"
    class="bg-transparent border-none p-0 focus:ring-0 text-dark-text text-[14px] md:text-[15px] font-medium placeholder:text-outline-gray w-full h-[22px]"
    [placeholder]="placeholder"
    type="text"
    autocomplete="off"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="open"
    [attr.aria-controls]="open ? uid + '-listbox' : null"
    [attr.aria-activedescendant]="open && activeIndex >= 0 ? uid + '-opt-' + activeIndex : null"
  />
  @if (open) {
    <div
      [id]="uid + '-listbox'"
      role="listbox"
      [attr.aria-label]="label"
      class="absolute left-0 top-[calc(100%+0.5rem)] w-full min-w-[18rem] max-w-[90vw] bg-white rounded-2xl border border-dark-text/10 shadow-[0_16px_40px_rgba(0,0,0,0.12)] overflow-hidden z-50"
    >
      <ul class="max-h-[20rem] overflow-y-auto divide-y divide-dark-text/8">
        @for (result of results; track $index) {
          <li>
            <button
              type="button"
              role="option"
              tabindex="-1"
              [id]="uid + '-opt-' + $index"
              [attr.aria-selected]="$index === activeIndex"
              (mousedown)="selectResult(result)"
              class="w-full text-left flex items-center gap-3 px-4 py-2.5 hover:bg-cream/60 transition-colors"
              [class.bg-cream]="$index === activeIndex"
            >
              <span
                class="material-symbols-outlined text-lg shrink-0"
                aria-hidden="true"
                [ngClass]="!result.id ? 'text-double-muted-text' : result.isBoondock ? 'text-jungle-green' : 'text-trinidad'"
                >{{ result.id ? 'location_on' : 'place' }}</span
              >
              <div class="flex-1 min-w-0">
                <div class="font-body text-sm text-dark-text truncate">{{ result.name }}</div>
                <div class="text-xs text-muted-text font-body truncate">
                  {{ result.id ? (result.city ? result.city + ', ' + result.state : 'Property') : result.state }}
                </div>
              </div>
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>
